MarketRate = require('market-rate-js')

utility = require('../../common/frontend/utility')

fixSearchWidget = () ->
  searchBar = $(".horiz-search-bar")
  offsetTop = searchBar.offset().top
  isFixed = false
  $(window).scroll ->
    offsetTop = searchBar.offset().top if not isFixed
    scrollTop = $(window).scrollTop()
    shouldBeFixed = scrollTop > offsetTop
    if shouldBeFixed and not isFixed
      searchBar.addClass('fixed')
      isFixed = true
    else if not shouldBeFixed and isFixed
      searchBar.removeClass('fixed')
      isFixed = false

module.exports =
  init: () ->
    moment.locale(I18n.locale)
    if utility.getLocalConfigProperty 'searchWidget'
      config = utility.getLocalConfigProperty 'calendar'
      if utility.getLocalConfigProperty 'seeMoreHotels'
        config.views.seeMoreHotels = true
      _.extend config,
        localization:
          i18n: I18n.scoped('modules.getaways_gallery')

      # Putting this within the Groupon.Getaways scope so it is possible
      #to access the .clearGallerySearchView() function in the galleryInstance.
      GallerySearch = MarketRate.Views.GallerySearch
      Groupon.Getaways.SearchView = new GallerySearch config
      Groupon.Getaways.SearchView.show $("#search_getaways_widget")

      $('.page_header h1').removeClass('underline-dots')
      if utility.getLocalConfigProperty 'scrollSearchBar'
        fixSearchWidget()
